<ppl-accordion [title]="'Processed Payroll'" [isOpen]="true">
    <div class="w-100">
        <ppl-timesheet-filter (searchEvent)="onSearch($event)" [filterFields]="filterFields"
            [includeBusinessStatus]="['P']"></ppl-timesheet-filter>

        @if(!timesheets || timesheets.length == 0) {
        <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to find
            the
            records</div>
        }
    </div>
    @if(timesheets.length > 0) {
    <div class="table-style">
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false" [enableActions]="false"
            [data]="timesheets" (rowDetailEvent)="rowClicked($event)" (rowDetailEventTs)="rowActions($event)" [disableSelection]="true" [cols]="cols"
            (gridAction)="onAction($event)" [gridTitle]="false" [pagination]="true" [loadPage]="true" [customDataLoaded]="true" (onPageLoad)="onPageLoad($event)"
            [showExpandIcon]="true" [actionButtons]="actionButtons" [showLineItem]="true" [lineItemCols]="lineItemCols">
        </ppl-list-table>
    </div>
    }
</ppl-accordion>

<div class="filter-panel">
    <ng-template #timesheetViewDialog let-cancel="cancel">
        <ppl-timesheet-detail-view [rowData]="selectedRowData" [lineItem]="selectedLineItem" [isProviderView]="true"
            (onProcessComplete)="onProcessComplete($event)" [timesheetFor]="'provider'" [isReadOnly]="isReadOnly"></ppl-timesheet-detail-view>
    </ng-template>
</div>


<div class="filter-panel">
    <ng-template #pdfDialog let-cancel="cancel">
        <div class="" *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="fieldsUpdated($event)" [readonly]="true" [pdfConfig]="pdfConfig"
                [signature]="" [pdfBlob]="pdfBlob" [pdfFile]="pdfFile" [signatureId]=""
                [isParticipantFlow]="isParticipantFlow" [selectedParticipantId]="selectedLead"
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
  </div>
